export function helpUrl(id: string, fragment = ''): string {
  return `/help?doc=${encodeURIComponent(id)}${fragment}`;
}

/** Resolve repository-relative Markdown links, heading anchors and bundled documentation assets. */
export function helpLink(page: string, href: string, assets: Readonly<Record<string, string>> = {}): string {
  if (/^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(href)) return href;
  const resolved = new URL(href, `https://help.invalid/${page}`);
  if (/\.md$/i.test(resolved.pathname)) {
    return helpUrl(decodeURIComponent(resolved.pathname.slice(1)), resolved.hash);
  }
  const asset = assets[decodeURIComponent(resolved.pathname.slice(1))];
  if (asset) return asset;
  return href.startsWith('#') ? helpUrl(page, resolved.hash) : href;
}

export function headingId(text: string): string {
  return text.toLowerCase().replace(/[^\p{L}\p{N}\s_-]/gu, '').replace(/\s/g, '-');
}
